<template>
  <div class="account-viewer" :class="{compact: compact}">
    <table class="key-value-table table">
      <thead>
        <tr>
          <th>
            <span class="compact-header">Nøgletal for regnskab</span>
            <!-- <div class="d-flex d-flex-grow justify-content-between align-items-center padding-left-2" @click="positiveNegative = !positiveNegative" style="cursor: pointer">
              <div class="selector d-flex justify-content-center" style="position: absolute;left: 0px;width: 30px; text-align:center" v-if="combinedWithChart" >
                <div class="check" :class="{ checked: positiveNegative }">
                  <i class="fa fa-check"></i>
                </div>
              </div>
              <span style="font-weight: 400">
                <span style="color: #019b85">Positiv</span> / <span style="color: #e84e3d">Negativ</span>
              </span>
              <i class="fa fa-info-circle text-muted pull-right hover-description"><span>Vis nøgletal med positive eller negative farver</span></i>
            </div>      -->
          </th>
          <th v-for="(account, index) in visibleAccounts" class="text-right" :key="account.period.to + index">
            <div class="download-pdf plausible-event-name=accounts+pdf+click" @click="openAccount(account)">
            <span style="position:relative">
              <div style="position: absolute; left: -62px;" v-show="index == 0 && (canGoBack || canGoForward)" class="scroll-account margin-right-2" :class="{enabled: canGoForward}" @click.stop="forward"><i class="fa fa-angle-left"></i></div>
              {{new Date(account.period.to).getFullYear()}}
            </span>
            <span class="filetype pdf" style="margin-left: 5px" title="Hent regnskabet"  v-show="account.reportUrl && (account.reportUrl.indexOf('.pdf') > -1 || account.reportUrl.indexOf('.xhtml') > -1)">PDF
              <i class="notification width-150" :tooltip="account.notifications.map(n => n.name).join(', ')" v-if="account.notifications.length" :title="account.notifications.name">{{account.notifications.length}}</i>
            </span>
            <span class="filetype pdf" title="Hent regnskabet i TIFF" v-show="account.reportUrl && account.reportUrl.indexOf('.tif') > -1">TIFF</span>
          </div>
          </th>
          <th style="width: 42px;">
            <div v-show="(canGoBack || canGoForward)" class="scroll-account" :class="{enabled: canGoBack}" @click="back"><i class="fa fa-angle-right"></i></div>
          </th>
        </tr>
      </thead>
      <tbody v-for="(keyf, index) in keyfiguresGrouped" :key="index">
        <tr v-for="(content, index) in keyf" :key="index">
          <td>
            <div class="d-flex d-flex-grow justify-content-between align-items-center ">
              <div class="selector d-flex justify-content-center" style="position: absolute;left: 0px;width: 30px; text-align:center" v-if="(combinedWithChart && nonInteractiveKeyFigures.filter(e => content.name === e).length === 0)">
                <div class="check" :class="{ checked: visibleOnChart.filter(element => content.name === element.name).length }">
                  <i class="fa fa-check"></i>
                </div>
              </div>
              {{content.title}}
              <Icon v-if="content.tooltip"  icon="info_outlined" size="small" :tooltip="content.tooltip" class="pull-right width-150" />
              <!-- <i class="fa fa-info-circle text-muted pull-right hover-description"><span>{{content.tooltip}}</span></i> -->
            </div>
          </td>
          <td v-for="(account, index) in visibleAccounts" class="table-value text-right" :colspan="accountsToShow === 1 ? 2 : 1" :key="index" >
            <key-value :positiveNegative="positiveNegative"
                        :show-errors="showErrors" :showUnit="account[content.name] && account[content.name].unit !== 'Percentage'" v-if="content.type.match( /(object|percentage)/ )"
                        :key-value="account[content.name]"
                        :thousands="thousands"
                        :percentage="content.type === 'percentage'" />
            <p class="margin-0 plausible-event-name=accounts+teaser+click" v-else-if="content.type === 'text' && content.name === 'teaser'">
              <span v-if="!account[content.name]">-</span>
              <a v-else href="#" @click.prevent="onClickTeaser()">Klik for at se</a>
            </p>
            <p class="margin-0 plausible-event-name=accounts+teaser+click" v-else-if="content.type === 'text' && content.name === 'general-teaser'">
              <a href="#" @click.prevent="onClickTeaser()">Se flere</a>
            </p>
            <p class="margin-0" v-else-if="content.type === 'text'">{{(account[content.name] && account[content.name].value) || '-'}}</p>
            <p class="margin-0" v-else-if="content.type === 'date'">{{accountPeriodFormat(account.period.from) + ' - ' + accountPeriodFormat(account.period.to) }}</p>
            <p class="margin-0" v-else-if="content.type === 'employees'">{{(account[content.name] && account[content.name].value) || '-'}}</p>
          </td>
          <td v-show="accountsToShow > 1"></td>
        </tr>
      </tbody>
    </table>
    <div v-if="showDisclaimer" class="disclaimer margin-top-2 padding-top-1 text-muted small">
      Regnskabsdata hentes fra de <a :href="'https://datacvr.virk.dk/data/visenhed?enhedstype=virksomhed&id=' + cvr" target="_blank">digitalt indberettede regnskaber</a> (XBRL-formatet). Vi tager forbehold for, at der kan være fejlindberetninger i disse.
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
// import Moment from 'moment'
import groupBy from 'lodash/groupBy'
import KeyValue from './KeyValue'
import Icon from 'vue-lasso-core/components/Icon.vue'
import { keyfigures }  from '@oldShared/lasso/utilities/accountUtils.js'
import userStore from '@/modules/users/store'
import { trackEvent } from '@/utils/googleAnalytics'
import windowSize from '@/window-size'

export default {
  name: 'accountsViewer',
  props: {
    accounts: {
      required: true,
      type: Array
    },
    compact: {
      type: Boolean
    },
    cvr: {
      type: String
    },
    thousands: {
      type: Boolean,
      default: false
    },
		showDisclaimer: {
			type: Boolean,
			default: false
    },
    showErrors: {
      type: Boolean,
      default: false
    },
    visibleOnChart: {
      type: Array
    },
    nonInteractiveKeyFigures: {
      type: Array,
      default: () => []
    },
    combinedWithChart: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
			currentIndex: 0,
      thead: null,
      theadPos: null,
      positiveNegative: false,
      allNull: []
    }
  },
  computed: {
    keyfigures () {
      const hasEbitda = this.visibleAccounts.some(a => a.ebitda)
      return [
        ...keyfigures,
        ... hasEbitda
          ? [{
            title: 'EBITDA',
            name: 'teaser',
            tooltip: 'Driftsresultat før goodwill og afskrivninger på driftsaktiviteter',
            type: 'text',
            filter: ['summary'],
            group: 5
          }]
          : [{
            title: '',
            name: 'general-teaser',
            type: 'text',
            filter: ['summary'],
            group: 5
          }]
      ]
    },
    validAccounts () {
      return this.accounts.filter(a => a.xbrlUrl)
    },
    accountsToShow: function () {
      if (windowSize.width < 600) return 1
      else if (windowSize.width < 968) return 2
      else return 3
    },
    prepareAccounts: function () {
      this.validAccounts.forEach(vA => {
        this.$set(vA, 'notifications', [])
        if (vA['goingConcern'] && vA['goingConcern'].value) vA.notifications.push({ name: 'Going concern', value: vA['goingConcern'].value })
        if (vA['supplementaryInformation'].length) vA.notifications.push({ name: 'Fremhævelser', value: vA['supplementaryInformation'].join(', ') })
        this.$set(vA, 'teaser', (!vA.ebitda && !vA.solvencyRatio) ? null : true)
      })
      return this.validAccounts
    },
    visibleAccounts: function () {
      return this.prepareAccounts.slice(this.currentIndex, this.currentIndex + this.accountsToShow)
    },
    canGoForward: function () {
      return this.currentIndex > 0
    },
    canGoBack: function () {
      return this.currentIndex < this.validAccounts.length - this.visibleAccounts.length
    },
    keyfiguresGrouped: function () {
      return groupBy(
        this.keyfigures.filter(kf => kf.filter.indexOf('summary') > -1),
        'group'
      )
    },

  },
  methods: {
    onClickTeaser () {
      userStore.showLoginToShowKeyfiguresDialog({
        lassoId: `CVR-1-${this.cvr}`,
        trackingEventName: 'accounts+teaser+click'
      })
    },
    openAccount: function (account) {
      window.open(account.reportUrl, '_blank')
    },
    forward: function () {
      if (this.canGoForward) this.currentIndex--
    },
    back: function () {
      if (this.canGoBack) this.currentIndex++
    },
    accountPeriodFormat: function (date) {
      let splittedDate = date.split('T')[0].split('-')
      return splittedDate[2] + '.' + splittedDate[1]
    },
    modifyVisibleOnChart: function (name) {
      var notificationConfigObj = { content: '', duration: 1500 }
      let modified = this.visibleOnChart
      let dataIndex = this.visibleOnChart.map(v => v.name).indexOf(name)
      let prettyName = this.$options.filters.accountDanishNames(name)
      if(dataIndex < 0) {
        notificationConfigObj.content = '"<b>'+prettyName + '</b>" blev tilføjet til grafen'
        modified.push({name: name, hidden: false})
      } else {
        notificationConfigObj.content = '"<b>'+prettyName + '</b>" blev fjernet fra grafen'
        modified.splice(dataIndex, 1)
      }
      this.Lasso.sdk.trigger('notification', notificationConfigObj);
      this.$emit('modifiedVisibleOnChart', modified)
    }
  },
  components: {
    'key-value': KeyValue,
    Icon
  },
}
</script>

<style lang="less">
  .account-viewer {
    .download-pdf {
      margin-left: auto;
      width: fit-content;
      padding-left: 8px;
    }
    .scroll-account {
      display: inline-block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background-color: #f2f2f2;
      border-radius: 2px 2px 0 0;
      color: #c5c5c5;
      &.enabled {
        cursor: pointer;
        color: #616161;
      }

      i {
        position: relative;
        top: 2px;
      }
    }

    .table {
      table-layout: fixed;
      margin-bottom: 0;
      thead {
        background-color: white;
        position: relative;
      }
      & tbody+tbody {
        border-width: 1px;
        border-top: 1px;
      }

      tbody:last-child td {
        border: none;
      }
      th {
        vertical-align: top;
        font-weight: 500;
        line-height: 32px;
        padding: 0;
				border-bottom: 1px solid #ededed;
				border-top: none;

        .compact-header {
          display: none;
          font-size: 16px;
        }
      }
      tr.interactive {
        cursor: pointer;
        &:hover {
          background-color: darken(white, 5%)
        }
      }
      td {
        padding: 8px 0;
        border-bottom: 1px solid #ededed;
        &:first-child {
          padding-left: 30px;
        }
        &.table-value {
          color: #616161;
          i {
            font-size: 14px;
          }
        }
      }

      tr td, tr th {
        &:nth-child(1) {
          padding-left: 16px;
        }

        &:nth-last-child(2) {
          padding-right: 16px;
        }
      }

      // tr:last-child td {
      //   // border: none;
      // }

    }
  }
  .check {
    border: 1px solid #dfdfdf;
    border-radius: 2px;
    height: 13px;
    width: 13px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 11px;
      display: none;
      color: #616161;
    }

    &.checked i {
      display: inline;
    }
  }
  i.hover-description {
    position: relative;
    cursor: help;
    font-style: normal;
    padding-top: 3px;
    span {
      position: absolute;
      bottom: 100%;
      margin: 0 0 5px 0;
      transform: translateX(-50%);
      display: none;
      width: 200px;
      font-size: 12px;
      line-height: 13px;
      font-style: normal;
      padding: 8px;
      background: #000;
      font-family: 'Roboto', sans-serif;
      color: #fff;
      box-shadow: 0 1px 10px 1px rgba(50, 50, 50, 0.1);
    }

    &:hover {
      span {
        display: block;
      }
    }
  }

  .account-viewer.compact {
    h3, .filetype {
      display: none;
    }
    tr td, tr th {
      padding-right: 0 !important;
      .compact-header {
        display: inline;
      }
      &:last-child {
        width: 0 !important;
      }
    }
  }
</style>
